module.exports = __webpack_public_path__ + "static/media/brand-alt.21ba0556.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly/dist/img/brand-alt.svg
// module id = 960
// module chunks = 0